define('v3/Common/Services/Backend/subjectGroupBackend',[
	'jquery',
	'BackendBase'
], function ($, BackendBase) {
	function SubjectGroupBackend () {
		BackendBase.call(this);
	};

	SubjectGroupBackend.prototype = $.extend({}, BackendBase.prototype);

	$.extend(SubjectGroupBackend.prototype, {
		getSubjectGroupsWhereEducationPlanExists: function () {
			return this._getJsonApi('SubjectGroups/GetAllSubjectGroupsWhereEducationPlanExists');
		},
		getPupilSubjectGroupsWhereEducationPlanExists: function (pupilId) {
			return this._getJsonApi('SubjectGroups/GetPupilSubjectGroupsWhereEducationPlanExists/' + pupilId);
		},
		getPupilSubjectGroupIdsWhereEducationPlanExists: function (pupilId) {
			return this._getJsonApi('SubjectGroups/GetPupilSubjectGroupIdsWhereEducationPlanExists/' + pupilId);
		},
		getSubjectGroupInfoBlock: function (subjectGroupId) {
			return this._getJsonApi('SubjectGroups/' + subjectGroupId + '/InfoBlock');
		},
		getSubjectGroupInfoBlockLessonPlan: function (subjectGroupId) {
			return this._getJsonApi('SubjectGroups/' + subjectGroupId + '/InfoBlockLessonPlan');
		},
		getAllSubjectGroups: function () {
			return this._getJsonApi('SubjectGroups');
		},
		getSubjectGroupDetails: function (subjectGroupId) {
			return this._getJsonApi('SubjectGroups/' + subjectGroupId + '/Details');
		},
		getSubjectGroupGradeDetails: function (subjectGroupId) {
			return this._getJsonApi('SubjectGroups/' + subjectGroupId + '/GradeDetails');
		},
		getSubjectGroupsInClassForSubject: function (subjectId) {
			return this._getJsonApi('SubjectGroups/ForSubject/' + subjectId);
		},
		removeLessonPlanForSubjectGroup: function (subjectGroupId) {
			return this._deleteApiWithJwtAuthorization(this._getApiUrl('LessonPlans/' + subjectGroupId));
		},
		getPupilIds: function (subjectGroupId) {
			return this._getJsonApi('SubjectGroups/' + subjectGroupId + '/PupilIds');
		}
	});

	return new SubjectGroupBackend();
});

